import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkle } from '@fortawesome/pro-regular-svg-icons';

export default function AiThinking() {
  const aiThinkingLines = [
    'Searching property databases for contact details...',
    'Looking up owner information and property records...',
    'Analyzing public records for contact information...',
    'Cross-referencing property data with contact databases...',
    'Verifying property ownership and contact accuracy...',
    'Compiling comprehensive contact information...',
  ];

  const [currentLineIndex, setCurrentLineIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLineIndex(prevIndex => (prevIndex + 1) % aiThinkingLines.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [aiThinkingLines.length]);

  return (
    <div className="ai-thinking d-flex gap-3 align-items-start p-3 rounded">
      <div className="icon-wrapper flex-grow-0 flex-shrink-0 p-2 rounded">
        
        <FontAwesomeIcon className="text-primary star-icon" icon={faSparkle} />
      </div>
      <div className="flex-grow-1 d-flex flex-column">
        <h6 className="mb-0 gradient-title-primary">
          <strong>Researching...</strong>
        </h6>
        <div className="text-muted d-flex flex-column">
          <div className="animated-lines position-relative">
            <span className="line animate-line fst-italic" key={currentLineIndex}>
              {aiThinkingLines[currentLineIndex]}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
